var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DxCheckBox',{attrs:{"on-value-changed":_vm.onSelectionChanged,"validationMessageMode":_vm.validationMessageMode,"text":_vm.getLabelText,"rtlEnabled":true,"element-attr":_vm.checkBoxAttributes},on:{"initialized":_vm.initialized}})
}
var staticRenderFns = []

export { render, staticRenderFns }